import React from "react";
import {compose} from "recompose";
import {withStyles} from "material-ui/styles/index";
import styles from "./styles";
import {connect} from "react-redux";
import {Heading} from 'react-aria-components';
import {
  Table,
  Cell,
  Column,
  Row,
  TableBody,
  TableHeader
} from "../../ui/react-aria/Table";
import {Modal} from "../../ui/react-aria/Modal";
import {Dialog} from "../../ui/react-aria/Dialog";
import {Button} from "../../ui/react-aria/Button";
import {Form} from "../../ui/react-aria/Form";

class SmartFlagsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isOpen !== this.props.isOpen || this.props.isOpen !== this.state.isOpen) {
      this.setState({isOpen: this.props.isOpen});
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({isOpen});

    if (!isOpen) {
      const {onClose} = this.props;
      if (onClose) {
        onClose();
      }
    }
  };

  smartFlagsTable() {
    const {classes, testId, smartFlagChecks} = this.props;

    const checks = smartFlagChecks ? smartFlagChecks.filter(c => String(c.testId) === String(testId)).map(c => {
      return {...c, id: `${c.category}-${c.categoryFlag}`};
    }) : [];

    return <div className={classes.tableContainer}>
      <Table aria-label="Smart Flags Checks" className={classes.table}>
        <TableHeader className={classes.tableHeader}>
          <Column isRowHeader>Flag</Column>
          <Column>Expected Value</Column>
          <Column>Actual Value</Column>
        </TableHeader>
        <TableBody items={checks}>
          {(item) => (
            <Row>
              <Cell>{item.name}</Cell>
              <Cell>{item.expectedValue}</Cell>
              <Cell>{item.actualValue}</Cell>
            </Row>
          )}
        </TableBody>
      </Table>
    </div>;
  }

  render() {
    const {classes} = this.props;
    const {isOpen} = this.state;

    return (
      <React.Fragment>
        <Modal isOpen={isOpen} isDismissable
               onOpenChange={(isOpen) => this.onOpenChange(isOpen)}>
          <Dialog>
            <div className={classes.root}>
              <Heading slot="title">Smart Flag Results</Heading>
              {this.smartFlagsTable()}
              <Form>
                <div className={classes.buttons}>
                  <Button slot="close" variant="secondary">Cancel</Button>
                </div>
              </Form>
            </div>
          </Dialog>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  smartFlagChecks: state.smartFlagReducer.smartFlagChecks,
  ...state
})

const mapDispatchToProps = (dispatch, props) => ({
})

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(SmartFlagsModal);
